import React from 'react';
import { Provider } from 'hooks-for-redux';
import { RouterProvider } from 'react-router-dom';
import mainRouter from './routing/main-router';

function App() {
    return (
        // @ts-expect-error hooks-for-redux does not properly handle TypeScript for its Provider
        <Provider>
            <RouterProvider router={mainRouter} />
        </Provider>
    );
}

export default App;
